function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M49,61H23a5.0147,5.0147,0,0,1-5-5V16a5.0147,5.0147,0,0,1,5-5H40.9091L54,22.1111V56A5.0147,5.0147,0,0,1,49,61Z",
    style: {
      fill: "#e3edfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,22.1111H44.1818a3.3034,3.3034,0,0,1-3.2727-3.3333V11s1.8409.2083,6.9545,4.5833C52.8409,20.0972,54,22.1111,54,22.1111Z",
    style: {
      fill: "#b7d0ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.03,59A4.9835,4.9835,0,0,0,23,61H49a4.9835,4.9835,0,0,0,3.97-2Z",
    style: {
      fill: "#c4dbf2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 31,
    width: 18,
    height: 2,
    rx: 1,
    ry: 1,
    style: {
      fill: "#7e95c4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 35,
    width: 18,
    height: 2,
    rx: 1,
    ry: 1,
    style: {
      fill: "#7e95c4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 39,
    width: 18,
    height: 2,
    rx: 1,
    ry: 1,
    style: {
      fill: "#7e95c4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 43,
    width: 14,
    height: 2,
    rx: 1,
    ry: 1,
    style: {
      fill: "#7e95c4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 47,
    width: 8,
    height: 2,
    rx: 1,
    ry: 1,
    style: {
      fill: "#7e95c4"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.9c7353fa685bb3884f68cc7e3204902b.svg";
export { ForwardRef as ReactComponent };